import React from "react";
import Icon from "../icons/Icon";

const Topbar = () => {
  return (
    <header className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-rbah-ink/10 tw-bg-white tw-px-8 tw-py-5">
      <div>
        <p className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-rbah-ink/60">
          Admin V2
        </p>
        <h1 className="tw-text-xl tw-font-bold tw-text-rbah-ink">
          RBAH Command Center
        </h1>
      </div>
      <div className="tw-flex tw-items-center tw-gap-3">
        <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-rbah tw-border tw-border-rbah-ink/10 tw-bg-rbah-off tw-px-4 tw-py-2">
          <Icon name="Search" className="tw-h-4 tw-w-4 tw-text-rbah-ink/70" />
          <span className="tw-text-sm tw-font-semibold tw-text-rbah-ink/60">
            Search signals
          </span>
        </div>
        <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-rbah tw-bg-rbah-ink tw-px-4 tw-py-2 tw-text-rbah-off">
          <Icon name="Shield" className="tw-h-4 tw-w-4 tw-text-rbah-lime" />
          <span className="tw-text-sm tw-font-semibold">Operator</span>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
